import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=20065aa4"
import script from "./Snackbar.vue?vue&type=script&lang=js"
export * from "./Snackbar.vue?vue&type=script&lang=js"
import style0 from "./Snackbar.vue?vue&type=style&index=0&id=20065aa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports